import React from 'react';
import { connect } from 'react-redux';
import errorSrc from 'images/error.svg';
import { hasError } from '../../../selectors';
import Loadable from '../loadable';
import IndexBlankSlate from './blankslate';
import TableLoadingState from './TableLoadingState';

const IndexDataView = ({
  isFetching,
  hasFailed,
  hasContent,
  hasResults,
  children,
  blankSlates,
  activeGroupCalculating,
  invalidSmartGroup,
  tableHeaders,
  selectable,
}) => {
  const hasData = !hasFailed && hasContent && hasResults;
  const noResults = !hasFailed && !hasResults;
  const noContent = !hasFailed && !hasContent;

  const defaults = {
    noResults: {
      description: t('common.display_message.description'),
    },
    hasFailed: {
      image: errorSrc,
      title: 'Pay No Attention to the Llama Behind the Curtain',
      description:
        'Sorry, an error occurred during the processing of your request, but refreshing the page may help.',
    },
  };

  const renderChildren = () => {
    if (isFetching)
      return (
        <TableLoadingState
          selectable={selectable}
          tableHeaders={tableHeaders}
        />
      );

    if (activeGroupCalculating)
      return (
        <IndexBlankSlate
          title={blankSlates.isCalculating.title}
          image={blankSlates.isCalculating.image}
          description={blankSlates.isCalculating.description}
        />
      );

    if (invalidSmartGroup)
      return (
        <IndexBlankSlate
          title={blankSlates.invalidSmartGroup.title}
          image={blankSlates.invalidSmartGroup.image}
          description={blankSlates.invalidSmartGroup.description}
          additionalDescription={
            blankSlates.invalidSmartGroup.additionalDescription
          }
        />
      );

    if (hasData) return children;

    if (noContent)
      return (
        <IndexBlankSlate
          title={blankSlates.noContent.title}
          icon={blankSlates.noContent.icon}
          image={blankSlates.noContent.image}
          description={blankSlates.noContent.description}
          additionalDescription={blankSlates.noContent.additionalDescription}
          children={blankSlates.noContent.children}
        />
      );

    if (noResults)
      return (
        <IndexBlankSlate
          title={blankSlates.noResults.title || defaults.noResults.title}
          image={blankSlates.noResults.image || defaults.noResults.image}
          icon={blankSlates.noResults.icon}
          description={
            blankSlates.noResults.description || defaults.noResults.description
          }
          additionalDescription={
            blankSlates.noResults.additionalDescription ||
            defaults.noResults.additionalDescription
          }
          children={blankSlates.noResults.children}
        />
      );

    if (hasFailed)
      return (
        <IndexBlankSlate
          title={blankSlates.hasFailed.title || defaults.hasFailed.title}
          image={blankSlates.hasFailed.image || defaults.hasFailed.image}
          icon={blankSlates.hasFailed.icon}
          description={
            blankSlates.hasFailed.description || defaults.hasFailed.description
          }
        />
      );

    return null;
  };

  return <Loadable>{renderChildren()}</Loadable>;
};

IndexDataView.defaultProps = {
  selectable: true,
};

const mapStateToProps = state => ({
  isFetching: state.data.isFetching,
  hasFailed: hasError(state),
  hasContent: !!state.data.totalManageable,
  hasResults: !!state.data.totalResults,
});

export default connect(mapStateToProps)(IndexDataView);
